<template>
    <div class="fhv-centent"  v-loading="loading" >
        <h4 class="title-topic">Account Management</h4>

        <el-form :model="From" 
            :rules="rules"
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item   label="Enable Anonymous Access:">
              <el-switch v-model="flag"  @change="changeBtn"></el-switch>
            </el-form-item>

             <el-form-item   label="User Name:" prop="user">
              <el-input v-model="From.user"></el-input>
            </el-form-item>

            <el-form-item   label="Password:" prop="pass">
              <el-input v-model="From.pass" type="password"></el-input>
            </el-form-item>
            
            <el-form-item   label="Confirmed Password:" prop="passAgain">
              <el-input v-model="From.passAgain" type="password"></el-input>
            </el-form-item>

            <el-form-item   label="" >
              <el-button type="primary" @click="add">Apply Changes</el-button>
            </el-form-item>
        </el-form>
      
        <p>Current Account Table:</p>
        <el-table :data="tableData" stripe style="width: 100%" border class="fhv-table">  
             <el-table-column type="index" width="150px" label="Number"></el-table-column>  
             <el-table-column prop="user" label="User Name"></el-table-column>
             <el-table-column fixed="right" label="Method" width="120">
                <template slot-scope="scope">
                    <el-button
                    @click.native.prevent="deleteRow(scope.$index,tableData)"
                    type="text"
                    size="small">
                    Delete
                    </el-button>
                </template>
             </el-table-column>
        </el-table>
        <div class="fhv-scan">
            <el-button type="primary"  @click="deleteRow('all')" :disabled="$G_DEVICE_CFG.isReadOnly">Delete_All</el-button>
            <el-button type="primary" @click="getData" :disabled="$G_DEVICE_CFG.isReadOnly">reset</el-button>
        </div>

    </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      flag: true,
      From: {
        user: "",
        pass: "",
        passAgain: ""
      },
      tableData: [
        /*  {
          user: "admin",
        } */
      ],
      rules: {
        user: [
          {
            required: true,
            message: "userName should not be NULL!",
            trigger: "blur"
          }
        ],
        pass: [
          {
            required: true,
            message: "passwd should not be NULL!",
            trigger: "blur"
          }
        ],
        passAgain: [
          {
            required: true,
            message: "confpasswd should not be NULL!",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (value!=this.From.pass) {
                callback(new Error("passwd should be equal to confpasswd!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    deleteRow(index, rows) {
      if (index == "all") {
        this.del(index);
      } else {
        this.del(index + 1);
      }
    },
    del(index) {
      if (index == "all") {
        var postData = {
          Delete_All: "Delete All",
          submit_url: "/accountmng.htm",
          userindex: ""
        };
      } else {
        var postData = {
          Delete_Selected: "Delete Selected",
          submit_url: "/accountmng.htm",
          userindex: ""
        };
        var name = `select${index}`;
        postData[name] = "ON";
      }

      this.loading = true;
      axios.post("/boafrm/setformDiskManagementUser", postData).then(res => {
        this.loading = false;
        this.getData();
      });
    },
    changeBtn() {
      let postData = {
        AnonEnabled: "",
        submit_url: "/accountmng.htm"
      };
      this.loading = true;
      if (this.flag == true) {
        postData.AnonEnabled = "ON";
      } else {
        postData.AnonEnabled = "";
      }
      axios.post("/boafrm/setformDiskManagementAnon", postData).then(res => {
        this.loading = false;
      });
    },
    getData() {
      this.loading = true;
      axios.post("/boafrm/getUserAccountsStatus").then(res => {
        this.loading = false;
        let data = res.data;
       
        if (data.StorageAnonAccessEnable == 1) {
          this.flag = true;
        } else {
          this.flag = false;
        }
        this.tableData = [];
        for (var i = 0; i < data.arr.length - 1; i++) {
          this.tableData.push({
            user: data.arr[i].userName
          });
        }
      });
    },
    add() {
      let postData = {
        username: this.From.user,
        newpass: this.From.pass,
        confpass: this.From.passAgain,
        "submit-url": "/accountmng.htm"
      };
   
      this.$refs["forms"].validate(valid => {
        if (valid) {
          this.loading = true;
          axios.post("/boafrm/setformDiskCreateUser", postData).then(res => {
            this.From.user = "";
            this.From.pass = "";
            this.From.passAgain = "";
            this.loading = false;
            this.$message.success(res.data.msg);
            this.getData();
          });
        }
      });
      
    }
  },
  created() {
    this.getData();
  }
};
</script>




